import React from 'react'

import { View, Text, Image, Button } from 'lib/components'
import { DocumentTitle } from 'lib/hooks/useDocumentTitle'
import * as routes from 'domains/application/navigation/routes'
import {isDistrictRoleSelector} from 'domains/authentication/selectors/roles'
import { useSelector } from 'react-redux'
import { meSelector } from 'domains/authentication/selectors/me'
import { userHasRole } from 'domains/users/models/IUser'
import * as roles from 'domains/users/constants/userRoles'
import { Link } from 'react-router-dom'
import { goToHelp } from 'domains/application/workflows/goToHelp'
import { applicationPropSelector } from 'domains/application/selectors/application'
import {
  EVENT_BUTTON_TEXT,
  EVENT_HEADER_IMAGE_URL,
  EVENT_HEADER_LINK_URL,
} from 'domains/application/models/configuration'

export default function ApplicationDashboardScreen() {
  const me = useSelector(meSelector)
  const isDistrict = useSelector(isDistrictRoleSelector)
  const linkUrl: string =
    useSelector(applicationPropSelector(EVENT_HEADER_LINK_URL)) ||
    'https://www.1edtech.org'
  const imageUrl: string = useSelector(
    applicationPropSelector(EVENT_HEADER_IMAGE_URL),
  )
  const buttonText: string = useSelector(
    applicationPropSelector(EVENT_BUTTON_TEXT),
  )

  return (
    <div>
      <View
        variant="screen"
        className="w-full bg-background py-12 flex flex-col gap-2"
      >
        <div className="flex items-center h-full w-full">
          <Image src={imageUrl} className="max-h-64 w-full" />
        </div>
        <a href={linkUrl} target="_blank" rel="noreferrer" className="ml-auto">
          <Button variant="secondary" large>
            {buttonText || 'Learn More'}
          </Button>
        </a>
      </View>
      <View variant="screen" className="my-4">
        <DocumentTitle title="Home" />
        <Text fontSize="jumbo" className="font-bold mx-32 my-8">
          Quick Links
        </Text>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4 transition-all duration-200 m-8 xl:mx-16 place-items-center">
          {isDistrict &&
            userHasRole(me, [
              roles.ADMIN_ROLE,
              roles.CCX_USER_ROLE,
              roles.TA_ADMIN_ROLE,
              roles.TA_CONTRIBUTOR_ROLE,
            ]) && (
              <Link
                className="bg-silver rounded-md drop-shadow-lg h-64 w-64 flex flex-col items-center justify-center p-4 hover:bg-blue-100 transition-colors cursor-pointer"
                to={routes.DISTRICT_TRUSTED_APPS_DASHBOARD_ROUTE}
                rel="noreferrer"
              >
                <Image
                  src="/images/TrustEdAppsDashboard.svg"
                  className="h-32 mb-4"
                />
                <Text fontSize="large" className="font-bold">
                  TrustEd Apps Dashboard
                </Text>
              </Link>
            )}

          {userHasRole(me, [roles.ADMIN_ROLE, roles.CCX_USER_ROLE]) && (
            <a
              className="bg-silver rounded-md drop-shadow-lg h-64 w-64 flex flex-col items-center justify-center p-4 hover:bg-blue-100 transition-colors cursor-pointer"
              href="https://www.1edtech.org/resource/dpsa"
              target="_blank"
              rel="noreferrer"
            >
              <Image src="/images/DPSA.svg" className="h-32 mb-4" />
              <Text fontSize="large" className="font-bold text-center">
                Data Privacy and Security Agreement
              </Text>
            </a>
          )}
          <a
            className="bg-silver rounded-md drop-shadow-lg h-64 w-64 flex flex-col items-center justify-center p-4 hover:bg-blue-100 transition-colors cursor-pointer"
            href="https://learn.1edtech.org"
            target="_blank"
            rel="noreferrer"
          >
            <Image src="/images/1EdTech Learn.svg" className="h-32 mb-4" />
            <Text fontSize="large" className="font-bold">
              1EdTech Learn
            </Text>
          </a>

          <a
            className="bg-silver rounded-md drop-shadow-lg h-64 w-64 flex flex-col items-center justify-center p-4 hover:bg-blue-100 transition-colors cursor-pointer"
            href="http://community.1edtech.org/"
            target="_blank"
            rel="noreferrer"
          >
            <Image src="/images/Community.svg" className="h-32 mb-4" />
            <Text fontSize="large" className="font-bold">
              Community
            </Text>
          </a>

          <a
            className="bg-silver rounded-md drop-shadow-lg h-64 w-64 flex flex-col items-center justify-center p-4 hover:bg-blue-100 transition-colors cursor-pointer"
            href="https://casenetwork.1edtech.org/"
            target="_blank"
            rel="noreferrer"
          >
            <Image src="/images/CASENetwork.svg" className="h-32 mb-4" />
            <Text fontSize="large" className="font-bold">
              CASE Network
            </Text>
          </a>
          <button
            className="bg-silver rounded-md drop-shadow-lg h-64 w-64 flex flex-col items-center justify-center p-4 hover:bg-blue-100 transition-colors cursor-pointer"
            onClick={() => {
              goToHelp()
            }}
          >
            <Image src="/images/Support.svg" className="h-32 mb-4" />
            <Text fontSize="large" className="font-bold">
              Support
            </Text>
          </button>
        </div>
      </View>
    </div>
  )
}
